import { Carousel } from "@/ui/Carousel";
import cn from "classnames";

import classes from "./styles.module.scss";

export default function ({ className = "py-0", images, prefix, EditableImage, theme = "light" }) {
  return (
    <div className={cn(className, classes.ImagesCarousel)} data-bs-theme={theme}>
      <Carousel
        autoplay={true}
        elementKey={prefix}
        breakpoints={{
          480: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
          1400: { slidesPerView: 4 },
        }}
        navigation={false}
        items={[...images, ...images].map(({ src, alt }, idx) => (
          <EditableImage key={idx} path={`img_${idx}`} src={src} size="380x303" alt={alt} />
        ))}
      />
    </div>
  );
}
